import OtherEventsPage from "../components/otherEvents/main";

const OtherEvents = () => {
  return <OtherEventsPage />;
};

export default OtherEvents;
